//------------------------------------------------------------------------------
// 地図部品
//------------------------------------------------------------------------------
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import '@esri/calcite-components/dist/components/calcite-action';
import { CalciteAction } from '@esri/calcite-components-react'

/**
 * 地図アクションボタン (開閉状態によるテキスト有効設定付きラッパー)
 */
export default function MapActionButton({ text, ...otherProps }) {

  // 地図動作設定 - 開閉状態
  const mapConfig = useSelector((state) => state.setting.mapConfig);

  // テキスト有効判定
  let textEnabled = text
      ? mapConfig.expandAction
      : false;
  if (!mapConfig.vertical) {
    textEnabled = false;
  }

  //
  // 描画
  //
  return (
    <CalciteAction
      text={text}
      textEnabled={textEnabled}
      {...otherProps}
    />
  );
}

// プロパティ
MapActionButton.propTypes = {
  text: PropTypes.string,    // テキスト
};
